/**
 * Product Lightbox v2
 * Simple image swap — no sliding track, no transforms, no drift
 */
(function() {

  var images = [];
  var currentSlide = 0;
  var touchStartX = 0;

  /* CREATE MODAL */
  var overlay = document.createElement('div');
  overlay.id = 'product-lightbox';
  overlay.setAttribute('style',
    'display:none;position:fixed;top:0;left:0;width:100%;height:100%;z-index:10000;' +
    'background:#fff;overflow:hidden;font-family:"IBM Plex Mono",monospace;'
  );
  overlay.innerHTML =
    '<div id="lb-close" style="position:absolute;top:12px;right:16px;font-size:1.6rem;cursor:pointer;z-index:10001;color:#000;font-weight:300;line-height:1;">&times;</div>' +
    '<div style="width:100%;height:100%;display:flex;flex-direction:column;box-sizing:border-box;">' +
      '<div id="lb-img-area" style="flex:none;height:60vh;display:flex;align-items:center;justify-content:center;padding:40px 20px 0;position:relative;touch-action:pan-y;user-select:none;overflow:hidden;">' +
        '<img id="lb-img" src="" style="max-width:100%;max-height:100%;object-fit:contain;display:block;">' +
        '<div id="lb-arrow-left" style="position:absolute;left:12px;top:50%;transform:translateY(-50%);font-size:2rem;cursor:pointer;color:#ccc;display:none;z-index:2;padding:8px;">&lsaquo;</div>' +
        '<div id="lb-arrow-right" style="position:absolute;right:12px;top:50%;transform:translateY(-50%);font-size:2rem;cursor:pointer;color:#ccc;display:none;z-index:2;padding:8px;">&rsaquo;</div>' +
      '</div>' +
      '<div id="lb-bottom" style="flex-shrink:0;text-align:center;padding:12px 20px 24px;">' +
        '<div id="lb-dots" style="display:flex;justify-content:center;gap:8px;margin-bottom:12px;"></div>' +
        '<div id="lb-sizes"></div>' +
        '<div id="lb-price" style="margin-top:8px;"></div>' +
      '</div>' +
    '</div>';
  document.body.appendChild(overlay);

  /* OPEN */
  document.addEventListener('click', function(e) {
    if (e.target.closest('.card__size-btn')) return;
    if (e.target.closest('#product-lightbox')) return;
    if (e.target.closest('#checkout-popup')) return;

    var card = e.target.closest('.card-wrapper');
    if (!card) return;

    e.preventDefault();
    e.stopPropagation();

    var cardImgs = card.querySelectorAll('.media--transparent img');
    var sizeSection = card.querySelector('.card__size-row');
    var priceSection = card.querySelector('.card__prices');
    if (cardImgs.length === 0) return;

    // Collect image sources
    images = [];
    var seen = {};
    cardImgs.forEach(function(img) {
      var fast = img.currentSrc || img.src;
      var hiRes = fast;
      if (img.srcset) {
        var parts = img.srcset.split(',');
        var last = parts[parts.length - 1].trim().split(' ')[0];
        if (last) hiRes = last;
      }
      var key = hiRes.split('?')[0];
      if (!seen[key]) {
        seen[key] = true;
        images.push({ fast: fast, hi: hiRes });
      }
    });

    // Dots
    var dots = document.getElementById('lb-dots');
    dots.innerHTML = '';
    if (images.length > 1) {
      for (var i = 0; i < images.length; i++) {
        var dot = document.createElement('span');
        dot.setAttribute('data-slide', i);
        dot.setAttribute('style', 'width:7px;height:7px;border-radius:50%;cursor:pointer;background:#ccc;transition:background 0.2s;');
        dots.appendChild(dot);
      }
    }

    // Arrows
    var arrowL = document.getElementById('lb-arrow-left');
    var arrowR = document.getElementById('lb-arrow-right');
    arrowL.style.display = images.length > 1 ? 'block' : 'none';
    arrowR.style.display = images.length > 1 ? 'block' : 'none';

    // Sizes
    var lbSizes = document.getElementById('lb-sizes');
    if (sizeSection) {
      lbSizes.innerHTML = '';
      var clone = sizeSection.cloneNode(true);
      clone.querySelectorAll('.card__size-btn').forEach(function(btn) {
        btn.style.fontSize = '1rem';
        btn.style.padding = '10px 18px';
        btn.style.border = '1px solid #000';
        btn.style.borderRadius = '0';
        btn.style.margin = '4px';
        btn.style.background = '#fff';
        btn.style.color = '#000';
        btn.style.cursor = 'pointer';
        btn.style.fontFamily = '"IBM Plex Mono", monospace';
        btn.style.minWidth = '44px';
        btn.style.minHeight = '44px';
        btn.style.display = 'inline-flex';
        btn.style.alignItems = 'center';
        btn.style.justifyContent = 'center';
        if (btn.disabled) {
          btn.style.borderColor = '#ddd';
          btn.style.color = '#ccc';
        }
      });
      lbSizes.appendChild(clone);
    } else {
      lbSizes.innerHTML = '';
    }

    // Price
    var lbPrice = document.getElementById('lb-price');
    lbPrice.innerHTML = priceSection ? priceSection.innerHTML : '';

    // Show & go to first image
    currentSlide = 0;
    showSlide(0);
    overlay.style.display = 'block';
    document.body.style.overflow = 'hidden';

    // Background upgrade
    images.forEach(function(img) {
      if (img.fast !== img.hi) {
        var p = new Image();
        p.src = img.hi;
      }
    });
  });

  /* SHOW SLIDE — just swap the src */
  function showSlide(n) {
    if (images.length === 0) return;
    if (n < 0) n = images.length - 1;
    if (n >= images.length) n = 0;
    currentSlide = n;

    var el = document.getElementById('lb-img');
    // Use hi-res if already cached, otherwise fast
    var test = new Image();
    test.src = images[n].hi;
    el.src = test.complete ? images[n].hi : images[n].fast;
    // Upgrade after
    if (!test.complete) {
      test.onload = function() {
        if (currentSlide === n) el.src = images[n].hi;
      };
    }

    // Update dots
    var dotEls = document.getElementById('lb-dots').children;
    for (var i = 0; i < dotEls.length; i++) {
      dotEls[i].style.background = i === currentSlide ? '#000' : '#ccc';
    }
  }

  /* CLOSE */
  function closeLightbox() {
    overlay.style.display = 'none';
    document.body.style.overflow = '';
    images = [];
    currentSlide = 0;
  }

  document.getElementById('lb-close').addEventListener('click', closeLightbox);
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closeLightbox();
  });
  document.addEventListener('keydown', function(e) {
    if (overlay.style.display !== 'block') return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') showSlide(currentSlide - 1);
    if (e.key === 'ArrowRight') showSlide(currentSlide + 1);
  });

  /* ARROWS */
  document.getElementById('lb-arrow-left').addEventListener('click', function(e) {
    e.stopPropagation();
    showSlide(currentSlide - 1);
  });
  document.getElementById('lb-arrow-right').addEventListener('click', function(e) {
    e.stopPropagation();
    showSlide(currentSlide + 1);
  });

  /* DOTS */
  document.getElementById('lb-dots').addEventListener('click', function(e) {
    var dot = e.target;
    if (dot.hasAttribute('data-slide')) {
      showSlide(parseInt(dot.getAttribute('data-slide')));
    }
  });

  /* SWIPE */
  var imgArea = document.getElementById('lb-img-area');

  imgArea.addEventListener('touchstart', function(e) {
    touchStartX = e.touches[0].clientX;
  }, { passive: true });

  imgArea.addEventListener('touchend', function(e) {
    var diff = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(diff) > 40) {
      if (diff < 0) showSlide(currentSlide + 1);
      else showSlide(currentSlide - 1);
    }
  });

  /* SIZE BUTTONS INSIDE LIGHTBOX */
  document.getElementById('lb-sizes').addEventListener('click', function(e) {
    var btn = e.target.closest('.card__size-btn');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var originalText = btn.textContent;
    btn.textContent = '...';

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('fail');
      return r.json();
    })
    .then(function() {
      btn.textContent = '\u2713';
      btn.style.background = '#000';
      btn.style.color = '#fff';

      return fetch(window.Shopify.routes.root + 'cart.js', {
        headers: { 'Accept': 'application/json' }
      });
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      if (typeof window.refreshBadges === 'function') window.refreshBadges();
      if (typeof window.updateSecureBar === 'function') window.updateSecureBar(cart.item_count);
      if (typeof window.pulseSecureBtn === 'function') window.pulseSecureBtn();
      if (typeof window.startHoldTimer === 'function') window.startHoldTimer();

      setTimeout(function() {
        btn.textContent = originalText;
        btn.style.background = '#fff';
        btn.style.color = '#000';
      }, 1200);
    })
    .catch(function(err) {
      btn.textContent = '!';
      setTimeout(function() { btn.textContent = originalText; }, 1500);
    });
  });

  /* PRELOAD ON HOVER */
  document.addEventListener('mouseover', function(e) {
    var card = e.target.closest('.card-wrapper');
    if (!card || card._preloaded) return;
    card._preloaded = true;
    var imgs = card.querySelectorAll('.media--transparent img');
    imgs.forEach(function(img) {
      if (img.srcset) {
        var parts = img.srcset.split(',');
        var last = parts[parts.length - 1].trim().split(' ')[0];
        if (last) { var p = new Image(); p.src = last; }
      }
    });
  }, { passive: true });

})();
